import { Checkbox, FormControl, FormControlLabel, IconButton, InputLabel, Menu, MenuItem, Select, Stack, TextField, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import OpcoesCampoCadastro from "./OpcoesCampoCadastro";

//Types Icons
import TextFieldsOutlinedIcon from '@mui/icons-material/TextFieldsOutlined';
import DialpadOutlinedIcon from '@mui/icons-material/DialpadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import ThumbsUpDownOutlinedIcon from '@mui/icons-material/ThumbsUpDownOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import { CampoCadastro, TipoCampoCadastro, TIPOS_IDENTIFICADOR } from "../../../interface/ICadastroModelo";

const TiposCampoOptions: { [key in TipoCampoCadastro]: string } = {
  "text": "Texto",
  "number": "Número",
  "doc": "Documento",
  "email": "Email",
  "phone": "Telefone",
  "list": "Lista",
  "boolean": "Verdadeiro/Falso",
  "date": "Data",
  "multiple": "Seleção Múltipla",
  "unique": "Seleção Única"
}


const TiposCampoIcons: { [key in TipoCampoCadastro]: React.ReactNode } = {
  "text": <TextFieldsOutlinedIcon />,
  "number": <DialpadOutlinedIcon />,
  "doc": <AttachFileOutlinedIcon />,
  "email": <AlternateEmailOutlinedIcon />,
  "phone": <CallOutlinedIcon />,
  "list": <SortOutlinedIcon />,
  "boolean": <ThumbsUpDownOutlinedIcon />,
  "date": <CalendarTodayOutlinedIcon />,
  "multiple": <CheckBoxOutlinedIcon />,
  "unique": <RadioButtonCheckedOutlinedIcon />
}
type CampoCadastroItemProps = {
  campo: CampoCadastro;
  updateCampo: (index: number, campo: Partial<CampoCadastro>) => void;
  deleteCampo: (index: number) => void;
  duplicateCampo: (index: number) => void;
  moveCampo: (index: number, direction: 'up' | 'down') => void;
  disableIdentificador: 'tipo' | 'jaExiste' | false;
  total: number;
  index: number;
}

const CampoCadastroItem = ({ campo, updateCampo, deleteCampo, duplicateCampo, moveCampo, disableIdentificador, total, index }: CampoCadastroItemProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  function handleMenuAction(action: () => void) {
    action();
    setAnchorEl(null);
  };

  function selectTipoCampo(tipo: TipoCampoCadastro) {
    updateCampo(index, { tipo, opcoes: [] });
    if ((tipo === 'multiple' || tipo === 'unique') && (!campo.opcoes || campo.opcoes.length === 0)) {
      updateCampo(index, { opcoes: ['Opção 1', 'Opção 2'] });
    }
    if (!TIPOS_IDENTIFICADOR.includes(tipo) && campo.identificador) {
      updateCampo(index, { identificador: false });
    }
  }

  const showIdOpt = campo.identificador;
  const showObrOpt = campo.obrigatorio;

  const identificadorToolTip = {
    tipo: 'Este tipo de campo não pode ser um identificador',
    jaExiste: 'Já existe outro campo identificador, só pode haver um'
  }

  return (
    <>
      <Stack gap={2} borderRadius={2} bgcolor='grey.50' sx={{ '&:hover .item-options': { opacity: '1' } }} border={1} borderColor='divider' padding={2} width='100%'>
        <Stack direction='row' width='100%'>
          <Typography width={'100%'} overflow={'hidden'} variant='h6' fontWeight={600} color='textPrimary' >{index + 1} - {campo.nome || 'Nome do Campo'}</Typography>
          <Stack direction='row' alignItems='center' >
            <Tooltip title={disableIdentificador && identificadorToolTip[disableIdentificador]} disableHoverListener={!disableIdentificador}>
              <FormControlLabel className='item-options' sx={{ opacity: showIdOpt ? '1' : '0', transition: '0.2s' }} disabled={!!disableIdentificador}
                control={<Checkbox checked={campo.identificador} onChange={() => updateCampo(index, { identificador: !campo.identificador, obrigatorio: true })} />}
                label='Identificador' />
            </Tooltip>
            <Tooltip title="Campo identificador precisa ser obrigatório" disableHoverListener={!campo.identificador}>
              <FormControlLabel className='item-options' sx={{ opacity: showObrOpt ? '1' : '0', transition: '0.2s' }} disabled={campo.identificador}
                control={<Checkbox checked={campo.obrigatorio} onChange={() => updateCampo(index, { obrigatorio: !campo.obrigatorio })} />}
                label='Obrigatório' />
            </Tooltip>
            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}><MoreVertIcon /></IconButton>
          </Stack>
        </Stack>
        <Stack direction='row' gap={2}>
          <TextField sx={{ bgcolor: "background.default" }} label="Nome do Campo" value={campo.nome || ''} onChange={(e) => updateCampo(index, { nome: e.target.value })} variant="outlined" fullWidth />
          <FormControl sx={{ width: 250 }}>
            <InputLabel id="demo-simple-select-label">Tipo do Campo</InputLabel>
            <Select label="Tipo do Campo" sx={{ bgcolor: "background.default" }} value={campo.tipo} onChange={(e) => selectTipoCampo(e.target.value as TipoCampoCadastro)} >
              {Object.entries(TiposCampoOptions).map(([key, value]) => (
                <MenuItem value={key} key={key}>
                  <Stack direction={'row'} alignItems={'center'} gap={1}>{TiposCampoIcons[key as TipoCampoCadastro]} {value}</Stack>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        {(campo.tipo === 'multiple' || campo.tipo === 'unique') && (
          <OpcoesCampoCadastro icon={TiposCampoIcons[campo.tipo]} opcoes={campo.opcoes ? campo.opcoes : []}
            onChange={(newOpcoes) => updateCampo(index, { opcoes: newOpcoes })} />
        )}
      </Stack>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem sx={{ display: "flex", gap: 1 }} onClick={() => handleMenuAction(() => moveCampo(index, 'up'))} disabled={index === 0}>
          <ArrowUpwardIcon /> Mover para cima
        </MenuItem>
        <MenuItem sx={{ display: "flex", gap: 1 }} onClick={() => handleMenuAction(() => moveCampo(index, 'down'))} disabled={index === total}>
          <ArrowDownwardIcon /> Mover para baixo
        </MenuItem>
        <MenuItem sx={{ display: "flex", gap: 1 }} onClick={() => handleMenuAction(() => duplicateCampo(index))} >
          <FileCopyOutlinedIcon /> Duplicar
        </MenuItem>
        <MenuItem sx={{ display: "flex", gap: 1, color: 'error.main' }} onClick={() => handleMenuAction(() => deleteCampo(index))} >
          <DeleteOutlineOutlinedIcon /> Deletar
        </MenuItem>
      </Menu>
    </>
  )
}

export default React.memo(CampoCadastroItem);
